module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f60d.e55f552b.svg";